var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMappinFocusedDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 68,
    viewBox: "0 0 56 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_446_42582)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_446_42582)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 63,
    rx: 9,
    ry: 3,
    fill: "black",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_446_42582)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 1C42.3594 1 54 12.6406 54 27C54 38.01 47.1565 47.4216 37.4913 51.2132L29.4806 62.1627C29.3136 62.3919 29.0919 62.579 28.8341 62.7082C28.5764 62.8373 28.2902 62.9048 27.9997 62.9048C27.7093 62.9048 27.4231 62.8373 27.1653 62.7082C26.9076 62.579 26.6858 62.3919 26.5188 62.1627L18.5079 51.2129C8.84308 47.4211 2 38.0097 2 27C2 12.6406 13.6406 1 28 1Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_446_42582",
    x: 17,
    y: 58,
    width: 22,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_446_42582"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_446_42582",
    x: -3,
    y: -3,
    width: 62,
    height: 71.9043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_446_42582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_446_42582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_446_42582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappinFocusedDefault);
export default __webpack_public_path__ + "static/media/mappin-focused-default.de6cd6d5265e4c247080d31177a073d3.svg";
export { ForwardRef as ReactComponent };